import '@LegacyJS/core';
import '@LegacyJS/components/in-app-purchases';
import '@LegacyJS/components/browser-helper';
import '@LegacyJS/components/toggle-button';
import {initDynamicallyLoadedBundlesNeededOnAllPages} from '@Utils/dynamic-bundle-load.util';


document.addEventListener('DOMContentLoaded', function () {
  initDynamicallyLoadedBundlesNeededOnAllPages();
});